import { html, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import css from './lib-accordion-group.css';

/** A headline and independently expandable accordion items sharing a host surface. */
@customElement('lib-accordion-group')
export class LibAccordionGroup extends LibElement {
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(css)];
  @property() headline = '';
  @property({ reflect: true }) surface = 'white';

  override render() {
    return html`<h3>${this.headline}</h3><div class="items"><slot></slot></div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-accordion-group': LibAccordionGroup; }
}
